import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.2fr_2fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-mic-2-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-2xl font-black tracking-tight text-foreground-950">
                  黑料地址
                </span>
                <span className="mt-1 text-[10px] tracking-[0.28em] text-foreground-500">
                  安全导航 · 真假辨别
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-700">
              我们只做安全验证与真假辨别的指引，帮你识别钓鱼网站、确认官方入口。本站不提供任何站外跳转担保，请在核对入口后再决定是否访问。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="#subscribe"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-notification-3-line" />
                订阅安全提醒
              </a>
              <a
                href="#verify"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
              >
                官方验证入口
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">{column.title}</h4>
                <ul className="mt-4 flex flex-col gap-3">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-700"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 黑料地址 · 安全验证特辑 · 内容仅供辨别参考
          </p>
          <p className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-600" />
              官方核验每日更新
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-information-line" />
              不诱导下载 · 不索取隐私
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}